import ImageCards from './modules/image-cards'
import { initComponent } from './lib/utils'
import './sections/main-product'
import './modules/accordion'

document.addEventListener('DOMContentLoaded', () => {
  initComponent(ImageCards, 'image-cards')
})
